module.exports = __webpack_public_path__ + "NanumBarunGothicOTFLight.eot";